'use client';

// Package Imports
import React, { FunctionComponent } from 'react';
import Slider from 'rc-slider';

// Types
import { PriceFilterProps } from '@/lib/types/filters';

// Style Imports
import 'rc-slider/assets/index.css';
import styles from './priceFilter.module.scss';
import mainStyles from '../searchFilters.module.scss';

const PriceFilter: FunctionComponent<PriceFilterProps> = ({
  min = 0,
  max = 0,
  step = 10,
  onSubmit,
  onChange,
  value,
}) => {
  const handleAfterChange = (val: number | number[]) => {
    if (Array.isArray(val)) {
      onSubmit(val);
    }
  };

  const ariaLabelsForHandles = ['Minimum price handle', 'Maximum price handle'];

  return (
    <div className={mainStyles.wrapper}>
      <div className={styles.sliderWrapper}>
        <span className={mainStyles.title}>Price</span>
        <Slider
          range
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={onChange}
          onChangeComplete={handleAfterChange}
          className={styles.slider}
          classNames={{
            handle: styles.handle,
            tracks: styles.tracks,
            track: styles.track,
            rail: styles.rail,
          }}
          ariaLabelForHandle={ariaLabelsForHandles}
        />
        <span className={styles.values} aria-live="polite">
          ${value[0]} – ${value[1]}
        </span>
      </div>
    </div>
  );
};

export default PriceFilter;
